export default __webpack_public_path__ + "static/media/error.4da09408.jpeg";